import './slider-root-widget.js';
import './slider-root-widget.css';
